




































































































































import { mapActions, mapGetters, mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import Title from '~/components/car/classifieds/view/partials/Header/Title.vue'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/favorite/CClassifiedFavoriteButton.vue'
import KeyFeaturesInColumns from '~/components/car/classifieds/view/partials/key-features/KeyFeaturesInColumns.vue'
import { ciOffers } from '~/icons/source/regular/offers'
import { ciCarcheck } from '~/icons/source/regular/carcheck'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { CategoryId } from '~/models/category/types'
import {
  defineComponent,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CPrice,
    CClassifiedFavoriteButton,
    Title,
    KeyFeaturesInColumns,
    CCard,
    PiraeusLoanButton: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/piraeus-loan/PiraeusLoanButton.vue'
      )
    )
  },
  props: {
    categoryId: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      currentUser: state => state.currentUser,
      categoryIds: state => state.classified.category_ids,
      seller: state => state.seller,
      pricePerUnit: state => state.classified.price_per_unit,
      leasing: state => state.leasing,
      classified: state => state.classified
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      userIsAdminOrOwner: 'userIsAdminOrOwner',
      hasLeasing: 'hasLeasing',
      isPartClassified: 'isPartClassified',
      hasOnlineFinancing: 'hasOnlineFinancing',
      showPiraeusMorgage: 'showPiraeusMorgage',
      showFinance: 'showFinance',
      isVehicleClassified: 'isVehicleClassified',
      isInsuranceAvailable: 'isInsuranceAvailable',
      isMapVariant: 'isMapVariant',
      showOnlineFinancing: 'showOnlineFinancing'
    }),
    showClassifiedNumber() {
      return Boolean(this.isPartClassified && this.classified?.id)
    },
    showPromoBadge() {
      if (this.isPromoted) {
        return this.$route.query['from-promotion'] || this.userIsAdminOrOwner
      }
      return false
    },
    priceParked() {
      return (
        this.classified.price.extra?.price_parked ||
        this.classified.price.extra?.priceParked
      )
    },
    priceToShow() {
      return this.priceParked
        ? this.priceParked + ' €'
        : this.classified.price.value
    },
    discountToShow() {
      if (this.priceParked) {
        return this.classified.price?.value
      }
      return this.classified.discount?.from_price
    },
    icons() {
      return { offers: ciOffers, carcheck: ciCarcheck }
    },
    isPlotCategory() {
      return this.categoryIds.includes(CategoryId.PLOT)
    },
    isFianceVisible() {
      return this.showFinance || this.showOnlineFinancing
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      classifiedParkedStateChanged: 'classifiedParkedStateChanged',
      scrollToLeasingPartial: 'scrollToLeasingPartial',
      scrollToFinance: 'scrollToFinance',
      scrollToInsurance: 'scrollToInsurance'
    })
  }
})
